import {
  Component, DestroyRef,
  HostListener,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {DsTooltipDirective} from "../../../../shared/directives/ds-tooltip/ds-tooltip.directive";
import {Website} from "../../website";
import {HostingData} from "../../hosting/info/hostingData";
import * as fromStore from "../../../../store";
import {distinctUntilChanged, filter, first, map, startWith, switchMap, takeUntil, tap} from "rxjs/operators";
import {combineLatest, Observable, Subject, Subscription} from "rxjs";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {Store} from "@ngrx/store";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {ActivityAction, ActivityStatus, IActivity} from "../../../../activities/activity";
import {AwsUploadService} from "../../../../shared/services/aws-upload/aws-upload.service";
import {User} from "../../../../user/user";
import {UserSubscription, UserSubscriptionCategory, UserSubscriptionType} from "../../../../user/user-subscription";
import {Config} from "../../../../config/config";
import {RechargeComponent} from "../../../../shared/components/dialogs/recharge-dialog/recharge.component";
import {
  NotificationDialogComponent
} from "../../../../shared/components/dialogs/notification-dialog/notification-dialog.component";
import {TextUtils} from "../../../../shared/utils/text-utils";
import {PaymentDialogComponent} from "../../../../workspace/billing/payment-dialog/payment-dialog.component";
import {CreateWebsiteService} from "../../../../services/local/create-website.service";
import {DialogService} from "../../../../../ng2-bootstrap-modal/dialog.service";
import {TypeUtils} from "../../../../shared/utils/type-utils";
import {
  OneWeekFreeDemoUpgradeComponent
} from "../../../../shared/components/dialogs/one-month-free/components/one-week-free-demo-upgrade/one-week-free-demo-upgrade.component";
import {DbModalService} from "../../../../modules/modal/modal";
import {Workspace} from "../../../../user-managment/workspace";
import {clientRoles} from "../../../../user/user-roles-actions";
import {GoogleAnalyticsService} from "../../../../shared/services/google-analytics/google-analytics.service";
import {RemoveWebsiteComponent} from "../../../remove-website/remove-website.component";
import {RemoveDemoComponent} from "../../../../shared/components/dialogs/remove-demo/remove-demo.component";
import {DbResponse} from "../../../../shared/interceptors/db-response";
import {NotifierComponent} from "../../../../shared/components/notifier/notifier.component";
import {Notification} from "../../../../shared/components/notifier/notification";
import {NotificationType} from "../../../../shared/components/notifier/notification-type";
import {HostingService} from "../../hosting/hosting.service";
import {Utils} from "../../../../shared/utils/utils";
import {CookieService} from "ngx-cookie";
import {HostingDomainData} from "../../hosting/domains/hostingDomainData";
import {ConfirmDialogComponent} from "../../../../shared/components/dialogs/confirm-dialog/confirm-dialog.component";
import {UserSubscriptionStatus} from "../../../../user/user-subscription-status";
import {Product} from "../../product";
import {BuilderV2Component} from "../../../../builder-v2/builder-v2.component";
import {
  NotificationModalComponent
} from "../../../../shared/components/dialogs/notification-modal/notification-modal.component";
import {BuilderHistoryService} from "../../../../builder-v2/builder-history.service";
import {
  CreateAiAssistantComponent
} from "../../../../components/pages/setup/create-ai/create-ai-assistant/create-ai-assistant.component";
import {WebsiteService} from "../../../website.service";
import {DashboardUtils} from "../../../../shared/utils/dashboard-utils";
import {GlobalEvent} from "../../../../shared/services/global-event-dispatcher/global-event";
import {
  GlobalEventDispatcherService
} from "../../../../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {
  GenerationFailedComponent
} from "../../../../components/pages/setup/create-ai/create-ai-assistant/generation-failed/generation-failed.component";
import {UserService} from "../../../../user/user.service";
import {RouteData} from "../../../../shared/services/route-data/route-data";
import {RouteDataService} from "../../../../shared/services/route-data/route-data.service";
import {BuilderSectionsInteractionService} from "../../../../builder-v2/builder-sections-interaction.service";
import {
  DemoProgressDoneComponent
} from "../../../../shared/components/dialogs/account-upgraded-dialog/demo-progress-done/demo-progress-done.component";
import {BuilderV2Service} from "../../../../builder-v2/builder-v2.service";
import {VibeCodingLimitationsData} from "../../../../builder-v2/vibe-coding-limitations.interface";
import {
    WebsiteCreationStatesDialogComponent
} from "../../../../shared/components/dialogs/website-creation-loading/website-creation-states-dialog.component";

@Component({
  selector: 'db-overview-page-header',
  templateUrl: './main-page-header.component.html',
  styleUrls: ['./main-page-header.component.scss'],
  standalone: false
})
export class MainPageHeaderComponent implements OnInit, OnDestroy, OnChanges {

  constructor(
      private _store: Store<fromStore.DbStoreState>,
      private _router: Router,
      private _route: ActivatedRoute,
      private _dialogService: DialogService,
      private _createWebsiteService: CreateWebsiteService,
      private _awsUploadService: AwsUploadService,
      private _modalService: DbModalService,
      private _hostingService: HostingService,
      private _cookieService: CookieService,
      private _builderHistoryService: BuilderHistoryService,
      private _googleAnalyticsService: GoogleAnalyticsService,
      private _globalEventDispatcher: GlobalEventDispatcherService,
      private _websiteService: WebsiteService,
      private _routeDataService: RouteDataService,
      private _userService: UserService,
      private builderHistoryService: BuilderHistoryService,
      private _builderSectionsInteractionService: BuilderSectionsInteractionService,
      private _builderV2Service: BuilderV2Service
  ) {
  }

  get hasBothBuilderServices(): boolean {
    return this.userSubscription && ['both'].includes(this.userSubscription.builderType)
        && this.userSubscription?.plan?.vibeService && this.userSubscription?.plan?.aiBuilderService;
  }

  get hasOnlyAiBuilderService(): boolean {
    return this.userSubscription && ['section_based', 'both'].includes(this.userSubscription.builderType)
        && !this.userSubscription?.plan?.vibeService && this.userSubscription?.plan?.aiBuilderService;
  }

  get hasOnlyViberService(): boolean {
    return this.userSubscription && ['wvc', 'both'].includes(this.userSubscription.builderType)
        && this.userSubscription?.plan?.vibeService && !this.userSubscription?.plan?.aiBuilderService;
  }

  get builderType(): string {
    // Check website type first
    if (this.website?.isWVC) {
      return 'wvc';
    } else if (this.website?.isSectionBased) {
      return 'sectionBased';
    }
    // Fallback to user subscription type
    if (this.hasOnlyViberService) {
      return 'wvc';
    } else if (this.hasOnlyAiBuilderService) {
      return 'sectionBased';
    }
    return localStorage.getItem('builderType') || 'wvc';
  }
  @Input() website: Website;
  @Input() demoUser: boolean;
  @Input() hostingInfoData: HostingData;
  @Input() primaryChanged: boolean;
  @Input() user: User;
  @Input() userSubscription: UserSubscription;
  @ViewChild('actionsTooltip', {static: false, read: DsTooltipDirective}) actionsTooltip: DsTooltipDirective;

  clientRoles = clientRoles;
  public isMobile: boolean;
  public disableCopyWebsite: boolean = false;
  public toggled: boolean = false;
  public passwordProtection: any;
  public disableControls: boolean;
  public canClone: boolean = false;
  public clearCacheLoading: boolean = false;
  public clearCacheFinished: boolean = false;
  public hasUpdate: boolean;
  public clearCachePercent: number = 0;
  public totalGeneratedWebsitesCount: number;
  public generatedWebsitesCount: number;
  public hostedWebsiteLimit: number;
  public hostedWebsitesIncludedMultiCount: number;
  public wpNewVersion: string;
  public readonly defaultStarterPlanId = Config.defaultStarterPlanId;
  public readonly basePlanId = Config.basePlanId;
  public dbTesting: boolean;
  public updatingWPVersion: boolean;
  public updatingWPVersionPercent: number = 0;
  public childWebsiteId: number;
  public previewUrl: string;
  public addAllDomains: HostingDomainData[];
  public removeAllDomains: HostingDomainData[];
  public createdPagesLoading$: Observable<boolean>;
  public disableAddPage: boolean;
  public hasSslCertificate: boolean;
  public canGenerateWebsites: boolean = true;
  public hideRemoveBtn: boolean = false;
  public userLocalStorage: any;
  public recreationFinished: Boolean = false;
  private previewLink = '';
  public websiteTenWebTheme: Product | null;
  public wvcTheme: Product | null;
  public websites: Website[];
  public currentWorkspace: Workspace;
  public vibeLimitations: VibeCodingLimitationsData;
  public _routeData: RouteData;
  public websites$: Observable<Website[]>;
  public redirectUrl: string;
  public showClearCache: boolean;
  public showVibeGenerationTooltip: boolean;
  public overlayVisible: boolean = false;
  public successPopupSeen: boolean = false;
  public showFailedDialog: boolean;
  public companyName: string = 'Dashboard';
  needRedirectToRegenerate = false;

  private _subscriptions: Subscription[];
  private _ongoingBuilderActivity$: Observable<IActivity>;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();
  private _interrupt$: Subject<boolean> = new Subject<boolean>();
  private _hasFiles: boolean = false;
  private _destroyRef = inject(DestroyRef);
  defaultBuilderOption: 'wvc' | 'section_based';

  protected readonly Config = Config;
  protected readonly setTimeout = setTimeout;

  ngOnInit() {
    this.defaultBuilderOption = this.website?.builderType || this.userSubscription?.availableBuilder;
    // Force section_based for multisite websites (WVC is not supported for multisite)
    if (this.website?.isNetwork && this.defaultBuilderOption === 'wvc') {
      this.defaultBuilderOption = 'section_based';
    }
    if (this.website && this.userSubscription) {
      const redirectPath = +this.website?.isWVC ? 'admin.php?page=wvc-editor'
          : '?edit.php?post_type=page&from=tenweb_dashboard&open=homepage';
      this.redirectUrl = this.website?.adminUrl + redirectPath;
      if (this.website?.isWVC) {
        this._listenVibeFiles();
        this._store.dispatch(new fromStore.LoadVibeFiles({domainId: this.website.id}));
      }
    }
    this.isMobile = window.innerWidth <= 991;
    this.hasSslCertificate = this._isValidHttpsUrl(this.website?.site_url);
    this._routeData = this._routeDataService.getCurrentRouteData();
    this._router.events
        .pipe(filter((event: any) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          this._routeData = this._routeDataService.getCurrentRouteData();
        });
    this.childWebsiteId =
        this.website?.isNetwork && this.website?.children
        && this.website?.children?.length ? this.website?.children[0] : null;
    if (this.userSubscription?.plan?.services?.ai_builder) {
      this._store.dispatch(new fromStore.LoadGeneratedWebsiteCount());
    }
    this.createdPagesLoading$ = this._store.select(fromStore.getCreatedPagesLoading(this.website.id));
    this.previewUrl = this.demoUser ? `${this.website?.site_url}?from=sidebar&client_id=${this.user.id}&domain_id=${Config.demoDomainId}&first_time` + (this.dbTesting ? `&db-testing` : ``) : this.website.site_url;
    this.dbTesting = !!this._cookieService.get('db-testing');
    this.hostedWebsiteLimit = this.userSubscription?.plan ? parseInt(this.user?.hosting_services?.domain_count?.parameter_value, 10) + this.user?.additionalWebsiteCount : null;
    this._getWebsite();
    this._getWvcTheme();
    this._getCompanyInfo();
    this._addEventHandlers();
    this._getRecreateOngoingActivity();
    this._awsIsUploading();
    if (this._route.snapshot?.queryParams['regenerate']) {
      this.openGenerationDialog(this.defaultBuilderOption);
      this._router.navigate([], {
        queryParams: {},
        replaceUrl: true
      });
    }
    this._globalEventDispatcher.vibeGenerateDialog$.next(this.openGenerationDialog.bind(this));
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['website']) {
      this.website = changes['website'].currentValue;
      const redirectPath = this.website?.isWVC ? 'admin.php?page=wvc-editor' : '?edit.php?post_type=page&from=tenweb_dashboard&open=homepage';
      this.redirectUrl = this.website?.adminUrl + redirectPath;
    }
  }

  private _getWebsite(): void {
    this._router.events
        .pipe(
            filter(event => event instanceof NavigationEnd),
            startWith(null),
            map(() => {
              this._routeData = this._routeDataService.getCurrentRouteData(); // update route data
              return this._routeData.queryParams.id; // extract `id` from queryParams
            }),
            distinctUntilChanged(), // only proceed if the ID changed
            switchMap(id =>
                this._store.select(fromStore.getWebsitesLoaded).pipe(
                    filter(loaded => loaded),
                    switchMap(() => this._store.select(fromStore.getWebsite(id)))
                )
            ),
            takeUntil(this._destroyStream$)
        )
        .subscribe((website: Website) => {
          if (website) {
            this.website = website;
            const redirectPath = this.website?.isWVC ?
                'admin.php?page=wvc-editor' : '?edit.php?post_type=page&from=tenweb_dashboard&open=homepage';
            this.redirectUrl = this.website?.adminUrl + redirectPath;
            this.hasSslCertificate = this._isValidHttpsUrl(this.website?.site_url);
            this.website?.id !== Config.demoDomainId && this._store.dispatch(new fromStore.LoadInfo(this.website?.id));
          }
        });
  }

  private _getCompanyInfo(): void {
    this._builderSectionsInteractionService.companyInfo
      .pipe(
        filter(companyInfo => !!companyInfo),
        takeUntil(this._destroyStream$),
        first()
      )
      .subscribe(companyInfo => {
        this.companyName = companyInfo?.branding?.company_name || companyInfo?.agency?.name || 'YourBrand';
      });
  }

  private _isValidHttpsUrl(string): boolean {
    try {
      const url = new URL(string);
      return url.protocol === 'https:';
    } catch (err) {
      return false;
    }
  }

  private _getWvcTheme(): void {
    this._store.select(fromStore.getWebsiteWvcTheme(this.website.id))
        .pipe(
            takeUntil(this._destroyStream$)
        )
        .subscribe(theme => this.wvcTheme = theme);
  }

  showDemoIframe(): void {
    this._globalEventDispatcher.dispatchEvent(GlobalEvent.showDemoPreviewIframe, {
      showIframe: true,
      iframeUrl: this.previewUrl
    });
  }

  private _addEventHandlers(): void {
    this._subscriptions = [];

    this._subscriptions.push(
        this._store.select(fromStore.getInfo(this.website.id)).subscribe((hostingInfo: any) => {
          if (hostingInfo) {
            this.hostingInfoData = hostingInfo;
          }
        })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getWebsites)
            .pipe(
                filter(websites => !!websites)
            )
            .subscribe(websites => {
              this.websites = websites.filter((website: Website) => website.type === 'live' && website.isNetwork && website.parentId && website.parentId === this.website.parentId);
              if (this.websites?.length && !!this.website?.parentId && this.websites[0]) {
                this.hideRemoveBtn = this.websites[0]?.id === this.website?.id;
              }
            })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getWpVersion(this.website?.id)).subscribe((wpVersion: any) => {
          if (wpVersion) {
            this.wpNewVersion = wpVersion;
            this.hasUpdate = this.website ? Utils.isUpdateAvailable(this.website.platformVersion, wpVersion) : false;
          }
        })
    );


    this._subscriptions.push(
        this._store.select(fromStore.getInfoLoaded(this.website?.id))
            .pipe(
                filter((loaded: boolean) => !!loaded),
                switchMap(() => this._store.select(fromStore.getInfo(this.website?.id))),
            )
            .subscribe((hostingInfo: any): void => {
              if (hostingInfo) {
                this.passwordProtection = hostingInfo && hostingInfo.hostingPasswordProtection;
              }
            })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getOngoingActivities)
            .pipe(
                distinctUntilChanged((activity1: IActivity, activity2: any) => activity1 && activity2 && activity1.id === activity2.id),
                filter((loaded: any) => loaded),
                switchMap(() => combineLatest(
                    this._store.select(fromStore.getMigrationOngoingActivity),
                    this._store.select(fromStore.getCreateWebsiteOngoingActivity),
                    this._store.select(fromStore.getAddWebsiteOngoingActivity)
                ))
            )
            .subscribe(([migrationActivity, createActiivity, addWebsiteActivity]) => {
              if (!migrationActivity && !createActiivity && !addWebsiteActivity) {
                this.disableCopyWebsite = false;
                return;
              }

              const ongoingActivity = migrationActivity ? migrationActivity : (createActiivity ? createActiivity : addWebsiteActivity);
              switch (ongoingActivity.status) {
                case ActivityStatus.DONE:
                case ActivityStatus.FAILED:
                  this.disableCopyWebsite = false;
                  break;

                default:
                  this.disableCopyWebsite = true;
                  break;
              }
            })
    );

    this._subscriptions.push(
        this._store
            .select(fromStore.getWebsitesLoaded)
            .pipe(
                takeUntil(this._destroyStream$),
                filter((loaded: boolean): boolean => !!loaded),
                switchMap(() => this._store.select(fromStore.getWebsites))
            )
            .subscribe((websites: Website[]) => {
              const hostedWebsitesWithMulti = websites.filter((website: Website) => !website.parentId && website.isActive && website.type === 'live' && !!website.domain_hash);
              this.hostedWebsitesIncludedMultiCount = hostedWebsitesWithMulti.length;
              this.canClone = this.website && this.user && this.website.domain_hash && !this.disableCopyWebsite && !this.website.isNetwork
                  && this.userSubscription && !this.userSubscription.isExpired
                  && !this.userSubscription.trialClient;

              if (this.userSubscription.status === UserSubscriptionStatus?.canceled &&
                  this.userSubscription
                  && this.userSubscription.plan && this.userSubscription.plan.services
                  && this.userSubscription.plan.services.hosting.domain_count
                  && this.hostedWebsitesIncludedMultiCount >= (
                      parseInt(this.userSubscription.plan.services.hosting.domain_count.parameter_value, 10) + this.userSubscription.plan.additionalDomainCount)) {
                this.canClone = false;
              }
            })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getCurrentWorkspace)
            .pipe(
                takeUntil(this._destroyStream$)
            )
            .subscribe(currentWorkspace => {
              this.currentWorkspace = currentWorkspace;
            })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getVibeLimitationsLoaded)
            .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => this._store.select(fromStore.getVibeLimitationsData)),
                first()
            )
            .subscribe((vibeLimitations: any) => {
              this.vibeLimitations = vibeLimitations;
            })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getOngoingActivity)
            .pipe(
                takeUntil(this._destroyStream$ || this._interrupt$),
                filter(activity => activity && activity.websiteId === this.website.id)
            )
            .subscribe(activity => {
              if ((activity.action === 'install_template' || activity.action === 'install_hosted_template')) {
                if (activity.status === ActivityStatus.RUNNING) {
                  this.disableAddPage = true;
                } else if (activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED) {
                  this.disableAddPage = false;
                }
              }
            })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getWebsiteTenWebTheme(this.website.id))
            .pipe(
                takeUntil(this._destroyStream$),
                filter(websiteTenWebTheme => !!websiteTenWebTheme),
            )
            .subscribe(websiteTenWebTheme => this.websiteTenWebTheme = websiteTenWebTheme)
    );

    this._subscriptions.push(
        this._store.select(fromStore.getUserLoaded)
            .pipe(
                filter((loaded: boolean) => loaded),
                switchMap(() => combineLatest(
                    this._store.select(fromStore.getGeneratedWebsitesCount),
                    this._store.select(fromStore.getRegeneratePermission),
                    this._store.select(fromStore.getUserLocalStorage),
                )),
                takeUntil(this._destroyStream$)
            )
            .subscribe(([generatedWebsitesCount, canRegenerate, userLocalStorage]) => {
              this.canGenerateWebsites = canRegenerate;
              this.userLocalStorage = userLocalStorage;

              if (this.userSubscription?.plan?.services?.ai_builder) {
                this.generatedWebsitesCount = generatedWebsitesCount;
                const regenerationWebsitesCount: number = parseInt(this.userSubscription.plan.services.ai_builder.regeneration_count.parameter_value, 10);
                const regenerationAdditionalWebsitesCount: number = parseInt(
                        this.userSubscription.plan.additionalDomainCount &&
                        this.userSubscription.plan.services.ai_builder.regeneration_additional_count ?
                            this.userSubscription.plan.services.ai_builder.regeneration_additional_count.parameter_value : 0, 10)
                    * this.userSubscription.plan.additionalDomainCount;
                this.totalGeneratedWebsitesCount = regenerationWebsitesCount + regenerationAdditionalWebsitesCount;
              }

            })
    );

    this._subscriptions.push(
        this._store.select(fromStore.getDomains(this.website?.id))
            .pipe(
                takeUntil(this._destroyStream$)
            )
            .subscribe((domains: HostingDomainData[]) => {
              this._store.select(fromStore.getCertificates(this.website?.id))
                  .subscribe((response: any) => {
                    const domainsMap: any = {};
                    if (response) {
                      response.map((data: any): any => domainsMap[data.domain_name] = data.status);
                      if (domains) {
                        this.addAllDomains = domains.filter((domainsList: any): boolean => {
                          if ((!domainsMap[domainsList.OGname] || (domainsMap[domainsList.OGname]
                                  && domainsMap[domainsList.OGname] === 'inactive'))
                              && !Utils.checkStringInArray(domainsList.OGname, Config.hostnameList)) {
                            return domainsList;
                          }
                          return false;
                        });
                        this.removeAllDomains = domains.filter((domainsList: any): boolean => {
                          if (domainsMap[domainsList.OGname] && domainsMap[domainsList.OGname] === 'active'
                              && !Utils.checkStringInArray(domainsList.OGname, Config.hostnameList)) {
                            return domainsList;
                          }
                          return false;
                        });
                      }
                    }
                  });
            })
    );
  }

  private _awsIsUploading(): void {
    this._awsUploadService.isUploading.subscribe(loading => {
      if (!!loading) {
        this.disableControls = true;
      }
    });
  }

  public cloneWebsite() {
    if (this.userSubscription
      && [UserSubscriptionType.TENWEBX_LTD, UserSubscriptionType.APPSUMO, UserSubscriptionType.TENWEBX_RECURRING,
        UserSubscriptionType.PREMIUM, UserSubscriptionType.ONE_PRODUCT].includes(this.userSubscription.type)
      && this.userSubscription.plan && this.userSubscription.plan.services
      && this.userSubscription.plan.services.hosting.domain_count
      && this.hostedWebsitesIncludedMultiCount >= (
        parseInt(this.userSubscription.plan.services.hosting.domain_count.parameter_value, 10) + this.userSubscription.plan.additionalDomainCount)
    ) {
      return this.showExceededDialog();
    } else {
      this._showCloneWebsiteDialog();
    }
  }

  private showExceededDialog() {
    if (this.user && this.user.subscriptionId === Config.defaultStarterPlanId) {
      return this.showCheckoutDialog('creation');
    }
    if (this.currentWorkspace && this.currentWorkspace.roleId
      && ![clientRoles.SITE_DEV, clientRoles.COMPANY_DEV].includes(this.currentWorkspace.roleId)
      && this.userSubscription && this.userSubscription.recharge) {
      const modal = this._modalService.open(RechargeComponent, {height: 208, width: 700});
      modal.componentInstance.userSubscription = this.userSubscription;
      return;
    }
    let exceededDesc = "text_domainsExceededUpgradeToHigher";
    let exceededBtnText = "text_upgrade";
    let exceededBtnColor = "green";
    let action = "upgrade";
    if (this.currentWorkspace && this.currentWorkspace.roleId === clientRoles.COMPANY_DEV) {
      action = "got it";
      exceededDesc = "text_domainsExceededContactOwner";
      exceededBtnText = "text_emailVerification.gotIt";
      exceededBtnColor = "blue";
    }
    if (this.userSubscription
      && [UserSubscriptionType.TENWEBX_LTD, UserSubscriptionType.APPSUMO,
        UserSubscriptionType.TENWEBX_RECURRING].includes(this.userSubscription.type)) {
      exceededDesc = 'text_domainsExceededBuyAdditional';
      exceededBtnText = "text_buyNow";
      exceededBtnColor = 'blue';
      action = 'buyNow';
    } else {
      switch (this.userSubscription.category) {
        case UserSubscriptionCategory.STARTER:
          exceededDesc = 'text_domainsExceededUpgradeToPaid';
          break;
        case UserSubscriptionCategory.PERSONAL:
        case UserSubscriptionCategory.PREMIUM:
          exceededDesc = 'text_domainsExceededUpgradeToHigher';
          break;
        case UserSubscriptionCategory.ENTERPRISE:
          exceededDesc = 'text_domainsExceededBuyAdditional';
          exceededBtnText = "text_buyNow";
          exceededBtnColor = 'blue';
          action = 'buyNow';
          break;
      }
    }
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_domainsExceededTitleDialog'),
      message: TextUtils.getText(exceededDesc),
      buttonText: TextUtils.getText(exceededBtnText),
      buttonColor: exceededBtnColor,
      action: action,
      hasCloseButton: true
    })
      .subscribe((confirmed: string): void => {
        if (confirmed) {
          if (confirmed === 'upgrade') {
            this._router.navigate(['/upgrade-plan']);
          } else if (confirmed === 'buyNow') {
            this._dialogService
              .addDialog(PaymentDialogComponent, {
                upgradeSubscription: this.userSubscription,
                fromDialog: true,
                showAdditional: true
              });
          }
        }
      });
  }

  private _showCloneWebsiteDialog(): void {
    this._createWebsiteService.openCloneWebsiteModal(this.website);
  }

  public openAdmin(): void {
        window.open(DashboardUtils.generateWpAdminRedirectorUrl(this.childWebsiteId ? this.childWebsiteId : this.website?.id, this.website?.adminUrl, this.user?.email), "_blank", "noopener");
  }

  public showCheckoutDialog(from: 'feature' | 'creation' | 'wp-admin' | 'editor' | 'clear-cache'): void {
    const analyticsData = {
      eventCategory: 'Free Upgrade Offer',
      eventAction: "Locked button click",
      eventLabel: from === 'clear-cache' ? 'Clear all Caches' : (from === 'feature' || from === 'wp-admin' ? "WP Admin" : "Edit Website")
    };

    if (this.demoUser) {
      const firstTime = TypeUtils.isNull(localStorage.getItem('dbShowFirstTime'));
      const options = {
        overflowHidden: false,
        backdropClass: 'blurred',
      };
      if (!firstTime) {
        options['width'] = 1240;
      } else {
        options['width'] = 460;
        options['height'] = 600;
      }
      const modal = this._modalService.open(OneWeekFreeDemoUpgradeComponent, options);
      modal.componentInstance.showFirstTime = firstTime;
    }
    this._googleAnalyticsService.sendAnalyticsEventWithCore(analyticsData);
  }

  public removeWebsite(): void {
    if (this.website && !!this.website.isAiBuilderDemo) {
      this._removeDemoWebsite();
    } else {
      const modal = this._modalService.open(RemoveWebsiteComponent);
      modal.componentInstance.website = this.website;
    }
  }

  private _removeDemoWebsite(): void {
    this._modalService.open(RemoveDemoComponent, {height: 233, width: 500});
  }


  public redirect(location): void {
    this._router.navigate([`/websites/${this.website.id}/${location}`]);
  }

  public clearCache(): void {
    if (this.demoUser && !this.dbTesting) {
      return this.showCheckoutDialog('clear-cache');
    }
    this._clearAllCaches();
  }

  private _clearAllCaches(): void {
    this.clearCacheLoading = true;
    this.clearCachePercent = 0;
    let fakeProgress = 0;

    // Start a simulated progress
    const progressInterval = setInterval(() => {
      if (fakeProgress < 95) { // Cap progress to 95% to leave space for real completion
        fakeProgress += 5; // You can adjust the speed here
        this.clearCachePercent = fakeProgress;
      }
    }, 100); // Every 200ms

    this._hostingService.clearAllCaches(this.website.id)
        .pipe(
            filter((response: DbResponse): boolean => !!response),
            first()
        )
        .subscribe((response: DbResponse): void => {
          clearInterval(progressInterval); // Stop the fake progress
          if (response.success) {
            this.clearCacheFinished = true;
            NotifierComponent.notify(new Notification(TextUtils.getText("text_site_cache_cleared"), NotificationType.SUCCESS));
          } else {
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          }

          this._changeCacheInProgressStatus();
          this.clearCacheLoading = false;
        });
  }


  private _changeCacheInProgressStatus(): void {
    setTimeout(() => {
      this.clearCachePercent = 100; // Set to 100% on real completion
      this.clearCacheFinished = false;
    }, 500);
  }


  public sectionBased(isRegenerateFromDemo: boolean = false, currentOutline = false): void {
  if (!this.canGenerateWebsites) {
      return this.showExceededRegenerateDialog();
    }
    else if (!this.websiteTenWebTheme) {
      this.showConfirmInstallDialog();
    } else {
      this.regenerateDialog({isRegenerateFromDemo, currentOutline});
    }
  }

  public showExceededRegenerateDialog(): void {
    this._dialogService
        .addDialog(ConfirmDialogComponent, {
          header: TextUtils.getText('text_youExceededTheLimitForAiGenerations'),
          message: this.userSubscription && this.userSubscription.category !== UserSubscriptionCategory.ENTERPRISE ? TextUtils.getText('text_youExceededTheLimitForAiGenerations') : TextUtils.getText('text_youExceededTheLimitForAiGenerationsDesc'),
          confirmButtonText: this.userSubscription && this.userSubscription.category !== UserSubscriptionCategory.ENTERPRISE ? TextUtils.getText('text_upgrade') : TextUtils.getText('text_contactUsTitle'),
          confirmButtonClass: 'ds-btn-blue ds-btn-s m rectangle',
          cancelButtonText: TextUtils.getText('text_cancel'),
          cancelButtonClass: 'ds-btn-white-gray-border white-bg ds-btn-s m short',
          alignLeft: true,
          fromStaging: true,
          hasCloseButton: false,
          width: '700px',
          height: '186px'
        })
        .subscribe((confirmed: boolean) => {
          if (confirmed) {
           if (this.userSubscription && this.userSubscription.status === UserSubscriptionStatus.canceled) {
             this._router.navigate(['/workspace/subscription-plan']);
            } else {
             this._router.navigate(['/upgrade-plan']);
            }
          }
        });
  }

  public showConfirmInstallDialog(): void {
    this._dialogService
        .addDialog(ConfirmDialogComponent, {
          header: 'Generate content<br/> and images with AI',
          message: '10Web builder theme will be installed<br/> automatically during generation.<br/> Your website will be replaced with a new one.',
          confirmButtonText: 'Got It',
          alignLeft: true,
          confirmButtonClass: 'ds-btn-black'
        })
        .subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.regenerateDialog();
          }
        });
  }

  private openChat() {
    window['Smooch']?.open();
    this._store.dispatch(new fromStore.ToggleChatOverlay(false));
  }


  public regenerateDialog($event?): void {
    localStorage.removeItem('showFinalize');
    if ($event && $event.isRegenerateFromDemo) {
      const storageData = this._builderHistoryService.getStateFromStorage();
      if ($event.currentOutline && storageData) {
        const builderV2 = this._modalService.open(BuilderV2Component, {
          fullHeight: true,
          hasCloseBtn: false,
        });
        builderV2.componentInstance.domainId = this.website.id;
        builderV2.componentInstance.website = this.website;
        builderV2.componentInstance.user = this.user;
        builderV2.componentInstance.popupMode = true;
        builderV2.componentInstance.currentOutline = true;
        builderV2.componentInstance.demoUser = this.demoUser;
        return;
      } else {
        return this._createAiAssistantDialog();
      }
    }
    const confirmationModal = this._modalService.open(NotificationModalComponent, {width: 700});
    confirmationModal.componentInstance.header = TextUtils.getText('text_regenerateTheEntireWebsite');
    confirmationModal.componentInstance.buttonAdditionalClass = 'ds-btn-black small-radius';
    confirmationModal.componentInstance.leftAlight = true;
    if (this.websiteTenWebTheme && this.websiteTenWebTheme.active) {
      confirmationModal.componentInstance.discardButtonTxt = 'Cancel';
      confirmationModal.componentInstance.discardButtonClass = 'ds-btn-outline-eggshell ds-btn-cancel m small-radius';
      confirmationModal.componentInstance.buttonAdditionalClass = 'ds-btn-black ds-btn-big m small-radius';
      confirmationModal.componentInstance.hideCloseBtn = 'true';
      confirmationModal.componentInstance.buttonTxt = 'Yes, regenerate my website';
      confirmationModal.componentInstance.uppercaseWords = false;
      confirmationModal.componentInstance.message = 'Generate a brand-new website using AI.<br/><br/>Your current website will be replaced with a new AI-generated version.<br/>Existing pages will be moved to Trash but can be restored at any time.';
    } else {
      confirmationModal.componentInstance.buttonTxt = TextUtils.getText('text_installActivate');
      confirmationModal.componentInstance.hideDialogDelay = 10;
      confirmationModal.componentInstance.buttonAdditionalClass = 'ds-btn-l';
      confirmationModal.componentInstance.message =
        `${TextUtils.getText('text_websiteGenerationWithAiIsNotAvailableWithYourCurrentTheme')}<br/> your current theme. ` +
        `<span>${TextUtils.getText('text_installActivateAniiBuilderThemeToGetAccess', {companyName: this.companyName})}</span> <br/>` +
        `<p class="mt20">${TextUtils.getText('text_theNewAiGeneratedPageWillBecomeYourSitesHomepage')}</p>`;
    }
    confirmationModal.closed.subscribe((value) => {
      if (value) {
          this._createAiAssistantDialog();
      }
    });
  }

  private _createAiAssistantDialog(): void {
    const modal = this._modalService.open(CreateAiAssistantComponent, {fullHeight: true});
    modal.componentInstance.websiteId = this.website.id;
    modal.componentInstance.website = this.website;
    modal.componentInstance.isOnboarding = false;
    modal.componentInstance.isFromGenerate = true;
    modal.componentInstance.showAsDialog = true;
    modal.componentInstance.popupMode = true;
  }

  private _getRecreateOngoingActivity(): void {
    this._store.select(fromStore.getOngoingActivity)
        .pipe(
            takeUntil(this._destroyStream$),
            tap(activity => activity && activity.meta && activity.meta.page_link && (this.previewLink = activity.meta.page_link)),
            filter(activity => !this.recreationFinished && activity && ((activity.websiteId && (activity.websiteId === this.website?.id || activity.websiteId === Config.demoDomainId)) || !activity.websiteId)
                && (activity.action === ActivityAction.INSTALL || activity.action === ActivityAction.INSTALL_HOSTED_TEMPLATE
                    || (activity.status === ActivityStatus.FAILED && activity.action === ActivityAction.AI_GENERATE_WEBSITE))
                && (activity.status === ActivityStatus.DONE || activity.status === ActivityStatus.FAILED))
        )
        .subscribe(activity => {
          this.userLocalStorage['seenNewAiFlow' + this.website?.id] = true;
          this._userService.setToLocal(this.userLocalStorage)
              .pipe(
                  first(response => !!response),
              )
              .subscribe(response => {
                if (response.success) {
                  this._store.dispatch(new fromStore.LoadUser());
                  this._store.dispatch(new fromStore.LoadUserLocalStorage());
                }
              });

          if (activity.status === ActivityStatus.DONE) {
            this._destroyStream$.next(true);
            this._destroyStream$.complete();
            this._modalService.dismissAll();
            this._dialogService.hasOpenedDialog() && this._dialogService.removeAll();
            this._successDialog();
            this._store.dispatch(new fromStore.LoadUserSubscription);
          }
          if (activity.status === ActivityStatus.FAILED) {
            localStorage.removeItem('prefilledAiData');
            this._modalService.dismissAll();
            this._dialogService.hasOpenedDialog() && this._dialogService.removeAll();
            this._showFailedDialog('outline');
          }
        });
  }

  private _showFailedDialog(mode?): void {
    localStorage.removeItem('showFinalize');
    const modal = this._modalService.open(GenerationFailedComponent, {width: 500, hasCloseBtn: true});
    modal.dismissed.subscribe(res => {
      if (mode !== 'outline') {
        if (res === 'chat') {
          this._router.navigate(['/websites']);
          this.openChat();
        } else {
          this._globalEventDispatcher.dispatchEvent(GlobalEvent.hideOnboardingBackButton, 0);
        }
      }
    });
  }

  public installAndActivate(product): any {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [product],
      action: !product.installed ? ActivityAction.INSTALL_ACTIVATE : ActivityAction.ACTIVATE,
      network: 0
    }));
  }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.classList.contains('actions-dropdown')
        && !target.parentElement?.classList.contains('actions-dropdown')) {
      this.toggled = false;
    }
    if (!(target as HTMLElement).closest('.db-main-header__websites-actions-list, .main-page-header__clear-caches')) {
      this.showClearCache = false;
    }
  }

  public clearCachesClick(): void {
    this.showClearCache = true;
    this.toggled = false;
    if (this.actionsTooltip) {
      (this.actionsTooltip as any)._hideTooltip();
    }
  }

  public update(): void {
    this.updatingWPVersion = true;
    this.updatingWPVersionPercent = 25;
    this._websiteService.coreUpdate(this.website.multisiteType === 'subfolder' ? this.website.children[0] : this.website.id)
        .pipe(filter((response: DbResponse): boolean => !!response),
            first())
        .subscribe((response) => {
          this.updatingWPVersionPercent = 90;
          if (response.success) {
            this.updatingWPVersion = false;
            this._store.dispatch(new fromStore.LoadWordpressVersion(this.website?.id));
            NotifierComponent.notify(new Notification('Successfully updated', NotificationType.SUCCESS));
          } else {
            this.updatingWPVersion = false;
            NotifierComponent.notify(new Notification(response.message, NotificationType.DANGER));
          }
        });
  }

  private _listenVibeFiles() {
    this._store.select(fromStore.getVibeFilesStatus(this.website.id))
        .pipe(takeUntilDestroyed(this._destroyRef))
        .subscribe(value => {
          this._hasFiles = value === 'success';
          this.needRedirectToRegenerate = true;
        });
  }

  handleEditClick(event?: Event): void {
    if (this.website?.isWVC && this.needRedirectToRegenerate) {
      event?.preventDefault();
      this._builderV2Service.getOngoingGenerationStatus(this.website.id)
          .pipe(
              filter((response: DbResponse): boolean => !!response),
              first()
          )
          .subscribe((response: DbResponse) => {
            if (response?.success && response?.data && response?.data?.is_ongoing === 1) {
              // If ongoing generation exists, redirect to wvc-editor
              this.redirectToWvcEditor();
            } else {
              // Otherwise, show the regenerate dialog
              if (this._globalEventDispatcher.vibeGenerateDialog$.value) {
                this._globalEventDispatcher.vibeGenerateDialog$.value();
              }
            }
          });
      return;
    }
    if (this.isMobile) {
      event?.preventDefault();
      // Open dialog for mobile
      const modal = this._modalService.open(DemoProgressDoneComponent, {hasCloseBtn: true});
      modal.componentInstance.forMobileEdit = true;
      modal.componentInstance.websiteId = this.website?.id;
      modal.componentInstance.user = this.user;
    }
  }

  redirectToWvcEditor() {
    DashboardUtils.redirectToWvcEditor(this.website, this.user, this.isMobile, true);
  }

  public generateWebsiteDialog(): void {
    const builderV2 = this._modalService.open(BuilderV2Component, {
      fullHeight: true,
      hasOutsideCloseBtn: true,
    });
    builderV2.componentInstance.domainId = this.website.id;
    builderV2.componentInstance.website = this.website;
    builderV2.componentInstance.user = this.user;
    builderV2.componentInstance.userSubscription = this.userSubscription;
    builderV2.componentInstance.popupMode = true;
    builderV2.componentInstance.currentOutline = false;
    builderV2.componentInstance.fromVibeCoding = true;
  }


  private _successDialog(): void {
    this._dialogService.addDialog(NotificationDialogComponent, {
      header: TextUtils.getText('text_congratsFromManager'),
      message: TextUtils.getText('text_websiteSuccessfullyGeneratedWithAI'),
      buttonText: TextUtils.getText('text_previewAndEdit'),
      buttonColor: 'black',
      hasGradientBorder: true,
      action: 'install_hosted_template',
      hasAdminLink: false,
      websiteId: this.website.id,
      hasCloseButton: false
    })
        .subscribe((confirmed: string): void => {
          if (confirmed === 'install_hosted_template') {
            const websiteUrl = this.website?.adminUrl + 'admin.php?page=wvc-editor&without_onboarding=1';
            window.open(DashboardUtils.generateWpAdminRedirectorUrl(this.website?.id, websiteUrl, this.user?.email), "_self", "noopener");
          }
        });
  }


  public vibeBased(): void {
      // Check if regeneration limit is reached
      const vibeLimitReached = this.userSubscription?.generationsTotal > 0
          && this.userSubscription?.generationsUsed >=
          this.userSubscription?.generationsTotal;

      if (vibeLimitReached) {
        return this.showExceededRegenerateDialog();
      }

      localStorage.removeItem('showFinalize');
      const message = `<div class="desc-list">
        <div class="desc-list-item">
            <i class="db-icon db-icon-ds-checkmark"></i>
            <span>Your current website will be replaced with a new AI-generated version.</span>
        </div>
        <div class="desc-list-item">
            <i class="db-icon db-icon-ds-checkmark"></i>
            <span>Existing pages will be moved to Trash but can be restored at any time.</span>
        </div>
        <div class="desc-list-item">
            <i class="db-icon db-icon-ds-checkmark"></i>
            <span>The ${this.companyName} AI Builder theme is required and will be installed and activated automatically.</span>
        </div>
      </div>`;
      const confirmationModal = this._modalService.open(NotificationModalComponent, {width: 700});
      confirmationModal.componentInstance.header = `Generate a brand-new website with ${this.companyName} AI`;
      confirmationModal.componentInstance.leftAlight = true;
      confirmationModal.componentInstance.discardButtonTxt = 'Cancel';
      confirmationModal.componentInstance.buttonTxt = 'Yes, generate new website';
      confirmationModal.componentInstance.discardButtonClass = 'ds-btn-outline-eggshell ds-btn-cancel m small-radius';
      confirmationModal.componentInstance.buttonAdditionalClass = 'ds-btn-black ds-btn-big m small-radius';
      confirmationModal.componentInstance.uppercaseWords = false;
      confirmationModal.componentInstance.message = message;
      confirmationModal.componentInstance.hideCloseBtn = 'true';
      confirmationModal.closed.subscribe((value) => {
        if (value) {
            this.generateWebsiteDialog();
        }
      });
  }

  onMouseEnter() {
    this.overlayVisible = true;
    setTimeout(() => {
      this.showVibeGenerationTooltip = true;
    }, 500);
  }


  public openGenerationDialog(model): void {
        if (this.website?.isNetwork && this.website.parentId) {
            model = 'section_based';
        }

        let limitReached = false;

        if (this.website?.builderType === 'section_based' || model === 'section_based') {
            // Section-based builder: check ai_builder regeneration limits
            if (this.userSubscription?.plan?.services?.ai_builder) {
                const regenerationWebsitesCount = parseInt(this.userSubscription.plan.services.ai_builder.regeneration_count?.parameter_value || '0', 10);
                const regenerationAdditionalWebsitesCount = parseInt(
                        this.userSubscription.plan.additionalDomainCount &&
                        this.userSubscription.plan.services.ai_builder.regeneration_additional_count ?
                            this.userSubscription.plan.services.ai_builder.regeneration_additional_count.parameter_value : '0', 10)
                    * (this.userSubscription.plan.additionalDomainCount || 0);
                const totalWebsitesCount = regenerationWebsitesCount + regenerationAdditionalWebsitesCount;

                limitReached = this.generatedWebsitesCount >= totalWebsitesCount;
            }
        }
        else {
            // Vibe coding: check vibe limitations
            limitReached = this.vibeLimitations?.create_limitations
                && this.vibeLimitations?.create_limitations?.already_used >= this.vibeLimitations?.create_limitations?.limitation + (this.vibeLimitations?.additional_credits?.total_credits || 0);
        }

        if (limitReached) {
            return this.showExceededRegenerateDialog();
        }

        localStorage.removeItem('showFinalize');


        // a. If website builderType is 'wvc' -> navigate to wvc editor with param regenerate=1
        if (this.website?.builderType === 'wvc' && (!this.website.isNetwork || this.website.isNetwork && !this.website?.parentId)) {
            DashboardUtils.redirectToWvcEditor(this.website, this.user, this.isMobile, true);
            return;
        }

        if ( model === 'wvc' ) {
            const modal = this._modalService.open(WebsiteCreationStatesDialogComponent, { width: 700, height: 262 });
            modal.componentInstance.user = this.user;
            modal.componentInstance.companyName = this.companyName;
            modal.componentInstance.description = '';
            modal.componentInstance.website = this.website;
            modal.componentInstance.step = 'regenerate';
            modal.componentInstance.userSubscription = this.userSubscription;
            modal.componentInstance.builderType = 'wvc';
            modal.componentInstance.websiteId = this.website?.id;
            return;
        }

        // b. If website builderType is 'section_based' -> open WebsiteCreationStatesDialogComponent with step regenerate
        if (this.website?.builderType === 'section_based' || model === 'section_based') {
            const modal = this._modalService.open(WebsiteCreationStatesDialogComponent, { width: 700, height: 262 });
            modal.componentInstance.user = this.user;
            modal.componentInstance.companyName = this.companyName;
            modal.componentInstance.description = '';
            modal.componentInstance.website = this.website;
            modal.componentInstance.userSubscription = this.userSubscription;
            modal.componentInstance.region = this.hostingInfoData?.hostingBasicInfo?.region || '';
            modal.componentInstance.step = 'regenerate';
            modal.componentInstance.builderType = 'section_based';
            modal.componentInstance.websiteId = this.website?.id;
            return;
        }

        /*// c & d. If website does not have builderType -> determine flow and open WebsiteCreationStatesDialogComponent
        // Determine builder type based on user subscription or other criteria
        const isWvcFlow = +this.userSubscription?.product_id === Config.vibeCodingPluginId;
        const builderType = isWvcFlow ? 'wvc' : 'section_based';
        // Both flows use 'regenerate' step with corresponding sizes: 700 x 262
        const width = 700;
        const height = 262;

        const modal = this._modalService.open(WebsiteCreationStatesDialogComponent, { width, height });
        modal.componentInstance.user = this.user;
        modal.componentInstance.description = '';
        modal.componentInstance.region = this.hostingInfoData?.hostingBasicInfo?.region || '';
        modal.componentInstance.step = 'regenerate';
        modal.componentInstance.website = this.website;
        modal.componentInstance.builderType = builderType;
        modal.componentInstance.websiteId = this.website?.id;*/
    }

  /**
   * Handles clicks on the "Edit your website" button for WVC websites.
   * Checks file status and ongoing build status to determine navigation
   */
  handleWvcEditClick(event?: Event): void {
    if (!this.website?.isWVC) {
      return;
    }

    event?.preventDefault();

    // If files exist, navigate directly
    if (this._hasFiles) {
      const url = DashboardUtils.getWvcEditUrl(this.website, this.user, true, false);
      window.open(url, '_blank');
      return;
    }

    // Files don't exist - check for ongoing build
    this._builderV2Service.getOngoingGenerationStatus(this.website.id)
      .pipe(first())
      .subscribe(
        (response: any) => {
          if (response?.data?.status === 'generating') {
            // Build in progress - open builder in "building" mode
            const url = DashboardUtils.getWvcEditUrl(this.website, this.user, true, true);
            window.open(url, '_blank');
          } else {
            // No build in progress and no files - regenerate
            DashboardUtils.redirectToWvcEditor(this.website, this.user, this.isMobile, true);
          }
        },
        () => {
          // Error checking status - default to regenerate
          DashboardUtils.redirectToWvcEditor(this.website, this.user, this.isMobile, true);
        }
      );
  }

  onVibeButtonClick() {
    // Check if should show tooltip on mobile
    const shouldShowTooltip = !this.website?.builderType && this.userSubscription?.multipleBuilder && !this.website?.isNetwork;

    if (this.isMobile && shouldShowTooltip) {
      // On mobile, show the tooltip
      this.overlayVisible = true;
      this.showVibeGenerationTooltip = true;
    } else if (!shouldShowTooltip || (this.website?.isNetwork && !!this.website.parentId)) {
      // Open generation dialog
      const builderType = (this.website?.isNetwork && this.website?.parentId) ? 'section_based' : this.defaultBuilderOption;
      this.openGenerationDialog(builderType);
    }
  }

  closeTooltip() {
    this.overlayVisible = false;
    this.showVibeGenerationTooltip = false;
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
    this._interrupt$.next(true);
    this._interrupt$.complete();
  }
}
